import React from "react";
import ReactDOM from "react-dom/client";
import { Currency } from "../../../js/common/CurrencyFormatter";
import insertProductToBasketService from "../basket/insert/InsertProductToBasketService";
import elementService from "../../../js/common/ElementService";
import ProductDetailPageTypeConfig, { ProductDetailInfo } from "./ProductDetailPageTypeConfig";
import ProductPriceComparisonModal from "./components/ProductPriceComparisonModal";
import productDetailInfoService from "./ProductDetailInfoService";

export default new class ProductPriceComparisonModalService {
    public init(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        if (pageTypeConfig.detailType !== "multi") {
            return;
        }

        this.initPackagePriceModals(pageTypeConfig, currency);
        this.initProductPriceModals(pageTypeConfig, currency);
    }

    public showProductPriceComparisonModal(
        newProductsDiscountCode: string,
        actionDiscountCode: string | null,
        megaClearanceSaleDiscountCode: string | null,
        cheapestPrice: number,
        productDetailInfo: ProductDetailInfo,
        currency: Currency,
        addProductToBasket: boolean,
    ): void {
        const containerElement = document.createElement("div");
        const root = ReactDOM.createRoot(containerElement);

        const addProductToBasketHandler = addProductToBasket
            ? (productId: number): void => insertProductToBasketService.showPopup(productId)
            : undefined;

        root.render(<ProductPriceComparisonModal
            productDetailInfo={productDetailInfo}
            cheapestPrice={cheapestPrice}
            newProductsDiscountCode={newProductsDiscountCode}
            actionDiscountCode={actionDiscountCode}
            megaClearanceSaleDiscountCode={megaClearanceSaleDiscountCode}
            currency={currency}
            onAddToBasket={addProductToBasketHandler}
            onAfterClose={(): void => {
                root.unmount();
                containerElement.remove();
            }}
        />);
    }

    private initPackagePriceModals(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        for (const priceButton of document.querySelectorAll<HTMLButtonElement>(".js-price-comparison-moreinfo-package")) {
            priceButton.addEventListener("click", (event: MouseEvent): void => {
                event.preventDefault();
                this.showProductPriceComparisonModal(
                    pageTypeConfig.newProductsDiscountCode,
                    pageTypeConfig.actionDiscountCode,
                    pageTypeConfig.megaClearanceSaleDiscountCode,
                    pageTypeConfig.cheapestPrice,
                    this.getFirstProductDetailInfo(pageTypeConfig),
                    currency,
                    false,
                );
            });
        }
    }

    private initProductPriceModals(pageTypeConfig: ProductDetailPageTypeConfig, currency: Currency): void {
        for (const priceButton of document.querySelectorAll<HTMLButtonElement>(".js-price-comparison-moreinfo-product")) {
            priceButton.addEventListener("click", (event: MouseEvent): void => {
                event.preventDefault();
                this.showProductPriceComparisonModal(
                    pageTypeConfig.newProductsDiscountCode,
                    pageTypeConfig.actionDiscountCode,
                    pageTypeConfig.megaClearanceSaleDiscountCode,
                    pageTypeConfig.cheapestPrice,
                    this.getProductDetailInfoByButton(pageTypeConfig, priceButton),
                    currency,
                    true,
                );
            });
        }
    }

    private getFirstProductDetailInfo(pageTypeConfig: ProductDetailPageTypeConfig): ProductDetailInfo {
        return pageTypeConfig.products[0];
    }

    private getProductDetailInfoByButton(pageTypeConfig: ProductDetailPageTypeConfig, priceButton: HTMLButtonElement): ProductDetailInfo {
        const productId = elementService.elementData(priceButton, "productId");

        return productDetailInfoService.getProductDetailInfo(pageTypeConfig, Number.parseInt(productId));
    }
}();
